import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { ADD_FAVORITE } from '../store/action/jokeAction'
import { BsFillStarFill } from 'react-icons/bs'

import React from 'react'
import './card.css'

const Card = (props) => {
    const dispatch = useDispatch()
    const favorites = useSelector(state => state.favorites)
    const { joke } = props
    let showButton = true

    favorites.map((el => {
        if(el.id === joke.id) {
            showButton = false
        }
    }))

    const handleFav = () => {
        dispatch(ADD_FAVORITE(joke))
    }

    return (
        <div key={joke.id} className="col-md-3 card-margin">
            <div className="card shadow jokes-card">
                <div className="card-body">
                    <div className="text-center">{joke.setup}</div>
                    <div className="text-center">{joke.punchline}</div>
                </div>
                {showButton ? <Button className="d-flex justify-content-center" onClick={() => handleFav()}><BsFillStarFill size="1.5em" color="#f1c40f" />Add To Favorite!</Button> : null}
            </div>
        </div>
    )
}

export default Card